module.exports = __webpack_public_path__ + "media/images/placeholder-c8557681c7c20feb1e7d98e4625d402d.png";